import * as React from "react";
const SvgInfoPrimary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M40 0C17.924 0 0 17.924 0 40s17.924 40 40 40 40-17.883 40-40S62.117 0 40 0m-.041 69.23a8 8 0 0 1-8.017-8.017 8 8 0 0 1 8.017-8.017 8 8 0 0 1 8.016 8.017 8 8 0 0 1-8.016 8.016m8.55-49.374-1.644 22.528c-.246 3.577-3.247 6.331-6.824 6.331s-6.577-2.754-6.824-6.33l-1.644-22.529c-.37-4.933 3.535-9.126 8.468-9.126 4.892 0 8.798 4.193 8.469 9.126"
    />
  </svg>
);
export default SvgInfoPrimary;
